import { Location } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorHandler, ModuleWithProviders, NgModule, Type } from '@angular/core';

import { AccountBase, SentryConfig } from './config';
import { RtcErrorHandler } from './error-handler';
import { RtLocation } from './location.service';
import { RateLimiterInterceptorService } from './rate-limiter-interceptor.service';

@NgModule()
export class RtcErrorHandlerModule {
  public static forRoot<S extends SentryConfig, A extends Type<AccountBase>>(
    sentryCfg: S,
    account: A,
  ): ModuleWithProviders<RtcErrorHandlerModule> {
    return {
      ngModule: RtcErrorHandlerModule,
      providers: [
        RtcErrorHandler,
        {
          provide: ErrorHandler,
          useExisting: RtcErrorHandler,
        },
        {
          provide: AccountBase,
          useExisting: account,
        },
        {
          provide: SentryConfig,
          useValue: sentryCfg,
        },
        {
          provide: Location,
          useExisting: RtLocation,
        },
        { provide: HTTP_INTERCEPTORS, useClass: RateLimiterInterceptorService, multi: true },
      ],
    };
  }
}
